import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { getProofRequest as getProofRequestAPI } from '../../util/api';

// ================ Action types ================ //

export const FETCH_PROOF_REQUEST_REQUEST = 'app/ShowPresentationPage/FETCH_PROOF_REQUEST_REQUEST';
export const FETCH_PROOF_REQUEST_SUCCESS = 'app/ShowPresentationPage/FETCH_PROOF_REQUEST_SUCCESS';
export const FETCH_PROOF_REQUEST_ERROR = 'app/ShowPresentationPage/FETCH_PROOF_REQUEST_ERROR';

// ================ Reducer ================ //

const initialState = {
  proofRequestData: null,
  fetchProofRequestInProgress: true,
  fetchProofRequestError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_PROOF_REQUEST_REQUEST:
      return {
        ...state,
        fetchProofRequestInProgress: true,
        fetchProofRequestError: null,
      };
    case FETCH_PROOF_REQUEST_SUCCESS:
      return {
        ...state,
        proofRequestData: payload,
        fetchProofRequestInProgress: false,
      };
    case FETCH_PROOF_REQUEST_ERROR:
      return {
        ...state,
        fetchProofRequestInProgress: false,
        fetchProofRequestError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchProofRequestRequest = () => ({
  type: FETCH_PROOF_REQUEST_REQUEST,
});

export const fetchProofRequestSuccess = data => ({
  type: FETCH_PROOF_REQUEST_SUCCESS,
  payload: data,
});

export const fetchProofRequestError = error => ({
  type: FETCH_PROOF_REQUEST_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const fetchProofRequest = requestId => (dispatch, getState, sdk) => {
  dispatch(fetchProofRequestRequest());

  return getProofRequestAPI(requestId)
    .then(htmlContent => {
      // The API now returns HTML content directly
      dispatch(fetchProofRequestSuccess(htmlContent));
      return htmlContent;
    })
    .catch(error => {
      log.error(error, 'fetch-proof-request-failed', {
        requestId,
      });
      dispatch(fetchProofRequestError(storableError(error)));
      throw error;
    });
};
